(function() {
    function isExcludedFromPromo(item) {
    if (!item) return false;
    var title = (item.title || item.product_title || '').toLowerCase();
    var handle = (item.handle || '').toLowerCase();
    var type = (item.product_type || '').toLowerCase();
    var props = item.properties || {};

    // 1. Patches (never count towards free gift milestone)
    if (title.indexOf('patch') !== -1 || handle.indexOf('patch') !== -1 || type.indexOf('patch') !== -1) {
      return true;
    }
    if (props['_Attached_to'] || props['Position'] || props['_is_patch']) {
      return true;
    }

    // 2. Keychains / Chaveiros (never count towards free gift milestone)
    if (title.indexOf('keychain') !== -1 || handle.indexOf('keychain') !== -1 || type.indexOf('keychain') !== -1) {
      return true;
    }
    if (title.indexOf('chaveiro') !== -1 || handle.indexOf('chaveiro') !== -1 || type.indexOf('chaveiro') !== -1) {
      return true;
    }

    // 3. Mystery Boxes (never count towards promo milestones, excluded like patches)
    if (title.indexOf('mystery') !== -1 || handle.indexOf('mystery') !== -1 || type.indexOf('mystery') !== -1) {
      return true;
    }
    if (title.indexOf('mistery') !== -1 || handle.indexOf('mistery') !== -1 || type.indexOf('mistery') !== -1) {
      return true;
    }
    if (title.indexOf('box') !== -1 || handle.indexOf('box') !== -1 || type.indexOf('box') !== -1) {
      return true;
    }

    return false;
  }

  var CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

  function calculateProgress(count) {
    var meta1 = 3;
    var meta2 = 5;
    var pct = 0;
    if (count >= meta2) {
      pct = 100;
    } else if (count >= meta1) {
      pct = 60 + ((count - meta1) / (meta2 - meta1)) * 40;
    } else if (count > 0) {
      pct = (count / meta1) * 60;
    } else {
      pct = 0;
    }
    return Math.min(100, Math.max(0, Math.round(pct)));
  }

  function getHeaderHtml(count) {
    if (count >= 5) {
      return '🎉 You unlocked 2 FREE jerseys!';
    } else if (count >= 3) {
      return '🎁 Keep going and get 2 FREE jerseys!';
    } else {
      return '🎁 You’re close to getting a FREE jersey!';
    }
  }

  function getMessageHtml(count) {
    if (count >= 5) {
      return '🎉 <strong>PROMO UNLOCKED!</strong> You got 2 jerseys free!';
    } else if (count === 4) {
      return '<strong>Almost there!</strong> Add 1 more and get 2 jerseys free! 🏃';
    } else if (count === 3) {
      return '🎉 <strong>1 Jersey Free Unlocked!</strong> Add 2 more to get 2 jerseys free! 🎁';
    } else if (count === 2) {
      return '<strong>Almost there!</strong> Add 1 more to get 1 jersey free! 🏃';
    } else if (count === 1) {
      return 'Add <strong>2 more jerseys</strong> to get 1 free!';
    } else {
      return 'Add <strong>3 jerseys</strong> to your cart and get 1 free!';
    }
  }

  var isUpdating = false;
  function updateBar(bar, count, prevCount) {
    if (!bar) return;
    isUpdating = true;
    try {
      bar.setAttribute('data-cpb-count', count);
      var pct = calculateProgress(count);
      var giftImg = bar.getAttribute('data-gift-img') || '/cdn/shop/t/1/assets/presente-barra.png';
      var giftIconHtml = '<img src="' + giftImg + '" alt="Gift" class="cpb-icon-img" width="16" height="16">';

      // 1. Fill width (with !important to ensure no CSS overrides)
      var fill = bar.querySelector('.cpb-fill');
      if (fill) {
        fill.style.setProperty('width', pct + '%', 'important');
        fill.style.setProperty('display', 'block', 'important');
        fill.style.setProperty('background-color', '#249A96', 'important');
        fill.style.setProperty('z-index', '2', 'important');
      }

      // 2. Header
      var header = bar.querySelector('.cpb-header-title');
      if (header) {
        header.innerHTML = getHeaderHtml(count);
      }

      // 3. Message
      var msgBox = bar.querySelector('.cpb-message-box');
      if (msgBox) {
        msgBox.innerHTML = getMessageHtml(count);
      }

      // 4. Node 1: START
      var startNode = bar.querySelector('.cpb-node-start');
      if (startNode) {
        if (count >= 1) {
          startNode.className = 'cpb-node cpb-node-start is-done';
          if (!startNode.querySelector('svg')) startNode.innerHTML = CHECK_SVG;
        } else {
          startNode.className = 'cpb-node cpb-node-start is-next is-pulse';
          if (startNode.querySelector('svg')) startNode.innerHTML = giftIconHtml;
        }
      }

      // 5. Node 2: Milestone at 60% (GET 3)
      var midMilestone = bar.querySelector('.cpb-milestone .cpb-node');
      if (midMilestone) {
        if (count >= 3) {
          midMilestone.className = 'cpb-node is-done';
          if (!midMilestone.querySelector('svg')) midMilestone.innerHTML = CHECK_SVG;
        } else if (count >= 1) {
          midMilestone.className = 'cpb-node is-next is-pulse';
          if (midMilestone.querySelector('svg')) midMilestone.innerHTML = giftIconHtml;
        } else {
          midMilestone.className = 'cpb-node';
          if (midMilestone.querySelector('svg')) midMilestone.innerHTML = giftIconHtml;
        }
      }

      // 6. Node 3: GET 5
      var endNode = bar.querySelector('.cpb-node-end');
      if (endNode) {
        if (count >= 5) {
          endNode.className = 'cpb-node cpb-node-end is-done';
          if (!endNode.querySelector('svg')) endNode.innerHTML = CHECK_SVG;
        } else if (count >= 3) {
          endNode.className = 'cpb-node cpb-node-end is-next is-pulse';
          if (endNode.querySelector('svg')) endNode.innerHTML = giftIconHtml;
        } else {
          endNode.className = 'cpb-node cpb-node-end';
          if (endNode.querySelector('svg')) endNode.innerHTML = giftIconHtml;
        }
      }

      // 7. Confetti Trigger on reaching Milestone 3 or 5
      if (typeof prevCount === 'number' && typeof window.cpbFireConfetti === 'function') {
        if ((prevCount < 3 && count >= 3) || (prevCount < 5 && count >= 5)) {
          window.cpbFireConfetti();
        }
      }
    } finally {
      setTimeout(function() { isUpdating = false; }, 50);
    }
  }

  var lastKnownCount = null;
  function syncCartState() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = 0;
        if (cart && cart.items) {
          cart.items.forEach(function(item) {
            if (!isExcludedFromPromo(item)) {
              count += item.quantity;
            }
          });
        }
        var prev = lastKnownCount;
        lastKnownCount = count;
        var bars = document.querySelectorAll('.cpb-container');
        bars.forEach(function(bar) {
          updateBar(bar, count, prev);
        });
      })
      .catch(function() {});
  }

  // Intercept fetch calls to Shopify cart endpoints
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function() {
      var promise = origFetch.apply(this, arguments);
      var url = arguments[0];
      if (typeof url === 'string' && (
        url.indexOf('/cart/add') !== -1 ||
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1 ||
        url.indexOf('/cart/clear') !== -1
      )) {
        promise.then(function() {
          setTimeout(syncCartState, 200);
        });
      }
      return promise;
    };
  }

  // Event Listeners for Dawn cart updates
  ['cart:updated', 'cart:item-added', 'cart:item-removed', 'cart:refresh', 'change'].forEach(function(evt) {
    document.addEventListener(evt, function() {
      setTimeout(syncCartState, 150);
    });
  });

  // Safe MutationObserver that ignores internal updates to prevent infinite loops
  var debounceTimer;
  var observer = new MutationObserver(function(mutations) {
    if (isUpdating) return;
    var relevant = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.addedNodes.length > 0) {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType === 1) {
            if (n.classList && (n.classList.contains('cart-drawer') || n.classList.contains('cart-items') || n.classList.contains('cpb-container') || n.id === 'CartDrawer-CartItems')) {
              relevant = true;
              break;
            }
            if (n.querySelector && n.querySelector('.cpb-container')) {
              relevant = true;
              break;
            }
          }
        }
      }
      if (relevant) break;
    }

    if (relevant) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncCartState, 150);
    }
  });

  function init() {
    var initialBar = document.querySelector('.cpb-container');
    if (initialBar) {
      var initialCount = parseInt(initialBar.getAttribute('data-cpb-count') || '0', 10);
      lastKnownCount = initialCount;
      updateBar(initialBar, initialCount);
    }
    observer.observe(document.body, { childList: true, subtree: true });
    syncCartState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
